import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';

// routing
const Themes = Loadable(lazy(() => import('./Themes')));

const ThemeRoutes = {
    path: 'theme',
    children: [
        {
            path: '',
            element: <Themes />
        }
    ]
};

export default ThemeRoutes;
